import React from "react";
import { useTranslation } from "react-i18next";

function InstructorToolkit() {
    const { t } = useTranslation();

    return (
        <section className='InstructorToolkit'>
            <div className='shell'>
                <div className='inner-wrapper'>
                    <div className='title'>
                        {/*{t("Instructor's Toolkit")}*/}
                    </div>

                    <div className='col-wrapper'>
                        <div className='the-left'>
                            <div className='title'>
                                {t("instructorToolkit.title")}
                            </div>
                            <div className='sub-title'>
                                {t("instructorToolkit.description")}
                            </div>
                            <div className='button-wrapper'>
                                <div className='btn features'>
                                    <a href='/contact'>Questions?</a>
                                </div>
                            </div>
                        </div>

                        <div className='the-right'>
                            <div className='toolkit-item'>
                                <div className='toolkit-title'>{t("instructorToolkit.Pre-Recorded Video")}</div>
                                <p>
                                    Pre-recorded videos give students the
                                    flexibility they need to start, stop and
                                    replay as often as they need to process
                                    course material. Upload your existing MP4
                                    video chapters for each section of your
                                    course.
                                </p>
                            </div>

                            <div className='toolkit-item'>
                                <div className='toolkit-title'>{t("instructorToolkit.Slide Shows")}</div>
                                <p>
                                    Visual learners need accompanying images to
                                    support their understanding of new
                                    vocabulary terms. Share PowerPoint
                                    presentations to combine the two and
                                    communicate with structure and clarity.
                                </p>
                            </div>

                            <div className='toolkit-item'>
                                <div className='toolkit-title'>{t("instructorToolkit.Articles and Resources")}</div>
                                <p>
                                    The depth and detail of articles and other
                                    text resources is unbeatable for linguistic
                                    learners. Post your e-books, pdfs, docs and
                                    other resources to the course page for easy
                                    reference and central storage.
                                </p>
                            </div>

                            <div className='toolkit-item'>
                                <div className='toolkit-title'>{t("instructorToolkit.Live Webinars")}</div>
                                <p>
                                    Sometimes, to understand the coordination of
                                    ideas, we need to see our instructors
                                    conduct demonstrations or interact in real
                                    time. Schedule synchronous learning
                                    opportunities using our webinar feature.
                                </p>
                            </div>

                            <div className='toolkit-item'>
                                <div className='toolkit-title'>{t("instructorToolkit.Quizzes & Exams")}</div>
                                <p>
                                    Compose multiple choice, reflective and
                                    descriptive questions to test the
                                    knowledge your students have acquired by
                                    taking your course. Set specific pass levels
                                    and use integrated marking tools to automate
                                    assessments.
                                </p>
                            </div>

                            <div className='toolkit-item'>
                                <div className='toolkit-title'>{t("instructorToolkit.Distribute Certificates")}</div>
                                <p>
                                    The reward for a job well done is a course
                                    certificate. Celebrate the skills your
                                    students have gained by taking your course
                                    and examination by issuing a custom
                                    electronic certificate of completion
                                    delivered via the yslearn platform.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div>
                        <p></p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default InstructorToolkit;
